export class SurveyFSESaveDto {
  constructor(
    public id: number,
    public version: number,
    public beneficiaryId: number,
    public communityActionId: number | undefined,
    public surveyContextId: number | undefined,
    public assessmentSourceId: number | undefined,
    public structureId: number,
    public year: string,
    public beginDate: Date | undefined,
    public endDate: Date | undefined,
    public exitQuestion1: boolean,
    public exitQuestion2: string | null | undefined,
    public exitQuestion3: string | null | undefined,
    public exitQuestion4: string,
    public exitQuestion5: string,
    public exitQuestion6: string,
    public exitQuestion7: string,
    public exitQuestion8: string,
    public entryQuestion1: string,
    public entryQuestion1e: string | undefined,
    public entryQuestion1f: string | undefined,
    public searchingSince: Date | undefined,
    public entryQuestion2: string,
    public entryQuestion3: string,
    public entryQuestion4: string,
    public entryQuestion4a: string,
    public entryQuestion4b: string,
    public entryQuestion4c: string,
    public entryQuestion4d: string,
    public entryQuestion4e: string,
    public entryQuestion4f: string,
    public entryQuestion4g: string,
    public entryQuestion4h: string,
    public entryQuestion5: string,
    public entryQuestion6: string,
    public entryQuestion7: string,
    public entryQuestion8: string,
    public entryQuestion9: string,
    public entryQuestion9a: string,
  ) {}
}
